import { DatePicker, Flex, Select } from "antd";
import React, { useState } from "react";
import Button from "../../Helpers/Button/Button";
import trans, { isRTL } from "../../../utils";
import dayjs from "dayjs";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { useGetPOIProjectsQuery } from "../../../Redux/service/POIS/POIs";

const { RangePicker } = DatePicker;
const { Option } = Select;

const IRHistoryHead = ({ filters, setFilters, onSubmit }) => {
  const dateFormat = "YYYY-MM-DD HH:mm:ss";

  const { data: projectsData } = useGetPOIProjectsQuery();

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setFilters({
        ...filters,
        startDate: dates[0].format(dateFormat),
        endDate: dates[1].format(dateFormat),
      });
    } else {
      setFilters({
        ...filters,
        startDate: null,
        endDate: null,
      });
    }
  };

  const handleTypeChange = (value) => {
    setFilters({ ...filters, type: value });
  };

  const handleProjectChange = (value) => {
    setFilters({ ...filters, project: value });
  };

  const handleDisciplineChange = (value) => {
    setFilters({ ...filters, discipline: value });
  };

  const handleRequestStatusChange = (value) => {
    setFilters({ ...filters, requestStatus: value });
  };

  const handleSearchChange = (e) => {
    setFilters({ ...filters, search: e.target.value });
  };

  const disciplines = [
    { value: "ELECTRICAL", label: "Electrical" },
    { value: "MECHANICAL", label: "Mechanical" },
    { value: "PLUMBING", label: "Plumbing" },
    { value: "CIVIL", label: "Civil" },
    { value: "ARCHITECTURAL", label: "Architectural" },
    { value: "OTHER", label: "Other" },
  ];

  const requestStatuses = [
    "DRAFT",
    "PENDING_QA",
    "QA_APPROVED",
    "QA_REJECTED",
    "PENDING_CONSULTANT",
    "CONSULTANT_APPROVED",
    "CONSULTANT_APPROVED_WITH_COMMENTS",
    "CONSULTANT_REJECTED",
    "CLOSED",
    "CANCELLED",
  ];

  const projectOptions = [
    { value: "all", label: trans("All Projects") },
    ...(projectsData?.data || projectsData || []).map((project) => ({
      value: project.id || project._id,
      label: project.name || project.title,
    })),
  ];

  return (
    <div className="report-sheet-head flex-between mb-3">
      <div />
      <Flex vertical={false} gap={10}>
        <Searchbar
          style="search search-dark input-group"
          placeholder={trans("Search")}
          value={filters?.search || ""}
          onChange={handleSearchChange}
          width={"250px"}
        />

        <Select
          allowClear
          placeholder={trans("Type")}
          style={{ width: 150 }}
          value={filters?.type}
          onChange={handleTypeChange}
        >
          <Option value="IR">{trans("IR")}</Option>
          <Option value="NCR">{trans("NCR")}</Option>
          <Option value="SNAG">{trans("SNAG")}</Option>
          <Option value="SUBMITTAL">{trans("SUBMITTAL")}</Option>
        </Select>

        <Select
          value={filters?.project}
          onChange={handleProjectChange}
          style={{ width: 200 }}
          placeholder={trans("Project")}
          loading={!projectsData}
        >
          {projectOptions.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>

        <Select
          allowClear
          placeholder={trans("Discipline")}
          style={{ width: 200 }}
          value={filters?.discipline}
          onChange={handleDisciplineChange}
        >
          {disciplines.map((discipline) => (
            <Option key={discipline.value} value={discipline.value}>
              {trans(discipline.label)}
            </Option>
          ))}
        </Select>

        <Select
          allowClear
          placeholder={trans("Request Status")}
          style={{ width: 220 }}
          value={filters?.requestStatus}
          onChange={handleRequestStatusChange}
        >
          {requestStatuses.map((status) => (
            <Option key={status} value={status}>
              {trans(status.replace(/_/g, " "))}
            </Option>
          ))}
        </Select>

        <RangePicker
          showTime
          value={
            filters?.startDate && filters?.endDate
              ? [
                  dayjs(filters.startDate, dateFormat),
                  dayjs(filters.endDate, dateFormat),
                ]
              : null
          }
          onChange={handleDateChange}
          placeholder={[trans("Start Date"), trans("End Date")]}
          format={dateFormat}
          style={{ maxWidth: 350 }}
        />

        {/* <Button
          img={!isRTL ? "Filter.svg" : ""}
          img2={isRTL ? "Filter.svg" : ""}
          onClick={onSubmit}
          type={"default"}
          text={trans("Apply Filters")}
        /> */}
      </Flex>
    </div>
  );
};

export default IRHistoryHead;
